module.exports = __webpack_public_path__ + "static/media/truck9b.341194ad.svg";